import data from "../../data/index.json";
import styled from 'styled-components';


const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
   flex: 1 1 ;
  gap: 20px;
  
`; 


export default function Mylogos() {

  return (
    <section className="portfolio--section" id="MyPortfolio">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <p className="sub--title">Recent Projects</p>
          <h2 className="section--heading">My Example Logos</h2>
        </div>
        <div>
        </div>
      </div>
      <Container>
      <div className="portlogo--section--container">
        {data?.logos?.map((item, index) => (
          <div key={index} className="portfolio--section--card">
            <div className="portfolio--section--img">
              <img src={item.src} alt="Placeholder" />
            </div>
            <div className="portfolio--section--card--content">
              <div>
                <h3 className="portfolio--section--title">{item.title}</h3>
                <p className="text-md">{item.description}</p>
              </div>
            </div>
            
          </div>
        ))}
      </div>
      </Container>
      <div > 
      <span style={{fontSize:"20px",color:"green"}}>Note! :</span>
        <p >if you have any idea about your own logo feel free to contact me bellow</p>
      </div>
    </section>
  );
}
